var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.name)+"\n  "),_c('input',{ref:"fileSelected",attrs:{"type":"file"},on:{"change":_vm.load}}),_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }